import React from 'react';
import './card.css';

export type CardVariant = 'default' | 'muted' | 'elevated' | 'gradient' | 'glass';

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  tone?: 'default' | 'muted';
  variant?: CardVariant;
  interactive?: boolean;
  noPadding?: boolean;
};

const Card: React.FC<CardProps> = ({
  header,
  footer,
  tone,
  variant = tone || 'default',
  interactive = false,
  noPadding = false,
  className = '',
  children,
  onClick,
  ...rest
}) => {
  const classes = [
    'ui-card',
    `ui-card--${variant}`,
    interactive ? 'ui-card--interactive' : '',
    noPadding ? 'ui-card--no-padding' : '',
    className,
  ].filter(Boolean).join(' ');

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (onClick) onClick(e);
  };

  return (
    <div
      className={classes}
      onClick={interactive ? handleClick : undefined}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      {...rest}
    >
      {header && <div className="ui-card__header">{header}</div>}
      <div className="ui-card__body">{children}</div>
      {footer && <div className="ui-card__footer">{footer}</div>}
    </div>
  );
};

export default Card;


